import { FontFamilies, Sizes, LineHeights, LetterSpacings, TextTransforms, Alignments } from '../../themes/default/typography/typography-tokens.js';
import { css } from 'styled-components';
import { TextStyleLegacySemanticsAll } from '../../themes/default/textStyle/textStyle-legacy-semantics.js';
import { TextStyleLegacyTokensAll } from '../../themes/default/textStyle/textStyle-legacy-tokens.js';
import { getStylesOptions, createBaseTextColors, generateThemedFontFamily } from './utils.js';
export { generateThemedFontFamily as themedFontFamily } from './utils.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TextSize = Sizes;
var TextStyle = _objectSpread(_objectSpread(_objectSpread({}, TextStyleLegacyTokensAll), TextStyleLegacySemanticsAll), getStylesOptions());
var TextLineHeight = LineHeights;
var TextLetterSpacing = LetterSpacings;
var TextTransform = TextTransforms;
var TextAlignment = Alignments;
var TextColor = createBaseTextColors();
var TextFontFamily = _objectSpread(_objectSpread({}, FontFamilies), {}, {
  SansSerif: 'SansSerif',
  Serif: 'Serif'
});
var fontFamily = "\n  DD-TTNorms,\n  -apple-system,\n  BlinkMacSystemFont,\n  \"Segoe UI\",\n  Roboto,\n  Helvetica,\n  Arial,\n  sans-serif,\n  \"Apple Color Emoji\",\n  \"Segoe UI Emoji\",\n  \"Segoe UI Symbol\"\n";
css(["font-size:", "px;font-family:", ";color:", ";margin:0;padding:0;"], function (props) {
  return props.size;
}, function (props) {
  return generateThemedFontFamily(props.themeFontFamily);
}, function (props) {
  return props.color;
}); // To Do: remove in v8 when legacy Typography system is removed
// This is an interim change to support Caviar MFP requirements and impending deadline.
// Come back and rethink the font weight strategy across `Text` and the entire project

var CaviarWeights = {
  Thin: '100',
  Light: '100',
  Regular: '300',
  Medium: '400',
  Bold: '500',
  ExtraBold: '700'
};
var StandardWeightMappings = {
  100: 'thin',
  200: 'extralight',
  300: 'light',
  400: 'regular',
  500: 'medium',
  600: 'demibold',
  700: 'bold',
  800: 'extrabold',
  900: 'black',
  Black: 900,
  ExtraBold: 800,
  Bold: 700,
  DemiBold: 600,
  Medium: 500,
  Regular: 400,
  Light: 300,
  ExtraLight: 200,
  Thin: 100
};

export { CaviarWeights, StandardWeightMappings, TextAlignment, TextColor, TextFontFamily, TextLetterSpacing, TextLineHeight, TextSize, TextStyle, TextTransform, fontFamily };
